import { ReactNode } from 'react'
import { Navbar } from './Navbar'
import { MenuVariantBanner } from './MenuVariantBanner'

interface MainLayoutProps {
  children: ReactNode
}

export function MainLayout({ children }: MainLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Navbar />
      <MenuVariantBanner />

      {/* Page Content */}
      <main className="flex-1 overflow-y-auto overflow-x-hidden bg-muted/20">
        <div className="w-full p-4 sm:p-6 md:p-8 max-w-7xl mx-auto min-w-0">
          <div className="animate-in fade-in-50 duration-300">
            {children}
          </div>
        </div>
      </main>
    </div>
  )
}
